import { render } from "./ItemPedido.vue?vue&type=template&id=508500f4&scoped=true"
import script from "./ItemPedido.vue?vue&type=script&lang=js"
export * from "./ItemPedido.vue?vue&type=script&lang=js"

import "./ItemPedido.vue?vue&type=style&index=0&id=508500f4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\musta\\Área de Trabalho\\Projetos\\catalogo\\catalogo-pedidos\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-508500f4"]])

export default __exports__